import {useCallback, useEffect} from 'react';
import {useRecoilState} from 'recoil';
import classNames from 'classnames';
import {ReactComponent as DownloadIcon} from '../../icons/bootstrap-download.svg'
import useGetDocumentQuery from '../../services/reactQueryHook/useGetDocumentQuery';
import {loadingState} from '../../atoms';
import {ILocale} from '../../services/utilis/ResponseObjects.types';

interface IRenderLocaleProps {
  isin: string,
  locale: ILocale,
  type: string,
  setError: (error: boolean) => void,
}

const RenderLocale = ({isin, locale, type, setError}: IRenderLocaleProps) => {
  const [loading] = useRecoilState(loadingState);

  const {refetch, isError} = useGetDocumentQuery({
    isin,
    documentType: type,
    documentLocales: locale.locale,
    tagSet: locale.tagSet
  });

  useEffect(() => {
    setError(isError);
  }, [isError, setError])

  const onDownload = useCallback(
    () => {
      if (!loading) {
        refetch(); //Download document
      }
    },
    [loading, refetch],
  )

  const prettifyLocale = (countryCode: String) => countryCode && countryCode.slice(0,2).toUpperCase();

  return (
    <div className={classNames('locale-column-container', {'locale-column-loading': loading})} onClick={onDownload}>
      <div className="locale-column-link">
        {prettifyLocale(locale.locale)}
      </div>
      <div className={'locale-column-icon-container'}>
        <DownloadIcon className={'locale-column-icon'} />
      </div>
    </div>
  )
}

export default RenderLocale
